import { $http, buildHeaders } from "./index";

//获取验证码
export const captcha = () => {
  return $http.get("/customer/Login/captcha", {
    headers: {
      unAuth: true,
    },
  });
};

//登录验证
export const judgeLogin = (data) => {
  return $http.post("/customer/Login/doLogin", data, {
    headers: {
      ...buildHeaders(3, "正在验证登录信息，请稍后……"),
      unAuth: true,
    },
  });
};

//获取登录用户信息
export const home_getuser = () => {
  return $http.get("/customer/Customer/info", {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//修改当前登录用户
export const home_setuser = (data) => {
  return $http.post("/customer/Customer/save", data, {
    headers: buildHeaders(3),
  });
};

//获取员工申报信息列表
export const employee_list = (params) => {
  return $http.get("/customer/ApplicationUnit/index", { params });
};

//获取员工申报信息详情
export const employee_detail = (id) => {
  return $http.get("/customer/ApplicationUnit/read?id=" + id, {
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取子账户列表
export const subaccount_list = (params) => {
  return $http.get("/customer/Subaccount/index", { params });
};

//更改子账户状态
export const subaccount_change = (data) => {
  return $http.post("/customer/Subaccount/updateStatus", data, {
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取工资表列表
export const payroll_list = (params) => {
  return $http.get("/customer/Payroll/index", { params });
};

//获取工资表详情
export const payroll_detail = (id) => {
  return $http.get("/customer/Payroll/read?id=" + id, {
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取工资表下员工数据
export const payroll_employee = (params) => {
  return $http.get("/customer/PayrollEmployee/index", { params });
};

//获取到款记录列表
export const bankreceived_list = (params) => {
  return $http.get("/customer/BankReceived/index", { params });
};

//获取到款记录详情
export const bankreceived_detail = (id) => {
  return $http.get("/customer/BankReceived/read?id=" + id, {
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

export const bankreceived_collects = (params) => {
  return $http.get("/customer/BankReceived/getCollects", { params });
};

//获取开票记录列表
export const invoice_list = (params) => {
  return $http.get("/customer/Invoice/index", { params });
};

//获取到款记录详情
export const invoice_detail = (id) => {
  return $http.get("/customer/Invoice/read?id=" + id, {
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

export const invoice_log = (invoice_id) => {
  return $http.get("/customer/Invoice/log", {
    params: { invoice_id, limit: 0 },
  });
};

//获取模板配置
export const salarytemplate_info = () => {
  return $http.get("/customer/SalaryTemplate/info", {
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//下载工资表模板
export const salarytemplate_download = () => {
  return $http.get("/customer/SalaryTemplate/download", {
    responseType: "blob",
    headers: buildHeaders(3, "正在下载文件，请稍后……"),
  });
};

//获取企业信息
export const customer_info = () => {
  return $http.get("/customer/Index/info", {
    headers: {
      ...buildHeaders(3, "数据加载钟，请稍后……"),
    },
  });
};
